import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { AutocompleteResult } from 'SearchApp/ts/interfaces/autocomplete-result.interface';

import { BaseAutocompleteComponent } from 'SearchApp/ts/features/base-autocomplete/components/base-autocomplete.component';

/**
 *
 * Icon Search Autocomplete Component
 *
 * Output Properties:
 *   submitHandler: EventEmitter that emits the selected AutocompleteResult
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-icon-search-autocomplete',
    templateUrl: './icon-search-autocomplete.template.html',
})
export class IconSearchAutocompleteComponent {
    @Input() appendToBody!: boolean;

    @Input() placeholder: string = 'Search';

    @Input() searchType!: string;

    @Input() defaultOnly: boolean = false;

    @ViewChild(BaseAutocompleteComponent) baseAutocompleter?: BaseAutocompleteComponent;

    @Output() submitHandler = new EventEmitter<AutocompleteResult>();

    focus(): void {
        if (this.baseAutocompleter) {
            this.baseAutocompleter.focus();
        }
    }

    reset(): void {
        if (this.baseAutocompleter) {
            this.baseAutocompleter.reset();
        }
    }
}
